// Funções úteis para a nova cotação da seguradora agrupadas em só lugar visando um futura V2

import services from '../../../../services';
import functions from '../../../../utils/functions';
import { AUTO, RCVAT } from '../../../../constants/tipo.apolice';

export default {
  async getTiposProposta(idTipoApolice) {
    try {
      if (!idTipoApolice) {
        idTipoApolice = 0;
      }

      const response = await services.getAll(
        'tipo-proposta',
        {},
        `list/${idTipoApolice}`,
      );

      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getTiposContratos() {
    const tipos = await functions.buscaDadosSelects(
      'domTipoContrato',
      [],
      'label',
      'idTipoContrato',
    );

    return tipos;
  },

  async getCarregamentos() {
    try {
      const response = await services.getAll(
        'carregamentos',
        {},
        `list/idEmpresa=null`,
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getAgravos(idTipoApolice) {
    try {
      if (!idTipoApolice) {
        idTipoApolice = AUTO;
      }

      const response = await services.getAll(
        'agravos',
        {},
        `list/idEmpresa=null/${idTipoApolice}`,
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  atribuirAgravosForm(agravos) {
    return agravos.map((c) => {
      return {
        [c.pergunta]: null,
      };
    });
  },

  atualizarAgravosPorGrupo(idGrupo, agravos) {
    const agravosEspecificos = agravos.filter((a) => {
      return (
        a.gruposEspecificos && a.gruposEspecificos.some((i) => i === idGrupo)
      );
    });

    const agravosComuns = agravos.filter((a) => a.grupoComum);

    return agravosComuns.concat(agravosEspecificos);
  },

  listarAgravosProposta(agravosProposta, listaAgravos) {
    const perguntas = agravosProposta.map((a) => Object.keys(a)[0]);
    return listaAgravos.filter((a) => perguntas.some((p) => p === a.pergunta));
  },

  atribuirCarregamentosForm(carregamentos) {
    return carregamentos.reduce((acc, curr) => {
      acc = {
        ...acc,
        [curr.label]: curr,
      };
      return acc;
    }, {});
  },

  add365Dias(data, subDays = 1) {
    const dataObjeto = this.dataObjeto(data);

    dataObjeto.setFullYear(dataObjeto.getFullYear() + 1);

    if (subDays >= 1) {
      dataObjeto.setDate(dataObjeto.getDate() - subDays);
    }

    const dia = dataObjeto.getDate();
    const mes = dataObjeto.getMonth() + 1;
    const ano = dataObjeto.getFullYear();

    return `${dia.toString().padStart(2, '0')}/${mes
      .toString()
      .padStart(2, '0')}/${ano}`;
  },

  diferencaMenor365Dias(dataString1, dataString2) {
    const dataObjeto1 = this.dataObjeto(dataString1);
    const dataObjeto2 = this.dataObjeto(dataString2);

    const diferencaEmMilissegundos = dataObjeto2 - dataObjeto1;
    const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

    return diferencaEmDias < 365;
  },

  dataObjeto(data) {
    let [dia, mes, ano] = data.split('/');
    return new Date(
      parseInt(ano, 10),
      parseInt(mes, 10) - 1,
      parseInt(dia, 10),
    );
  },
};
